import { useRouter } from 'vue-router'

import { SINGLE_PROJECT_ROUTES_NAMES } from '~/router'

const PHASE_TO_ROUTE: Readonly<Record<string, SINGLE_PROJECT_ROUTES_NAMES>> = {
	Anlagenzertifizierung: SINGLE_PROJECT_ROUTES_NAMES.PlaintCertificateChecklist,
	Konformitätserklärung: SINGLE_PROJECT_ROUTES_NAMES.ConfirmityCheckChecklist
}

export const useSingleProjectTransition = () => {
	const router = useRouter()

	const singleProjectTransition = (
		projectId?: string | number,
		phase?: string
	): void => {
		if (!projectId) return

		const routeName =
			(phase && PHASE_TO_ROUTE[phase]) ??
			SINGLE_PROJECT_ROUTES_NAMES.PlaintCertificateChecklist

		router.push({ name: routeName, params: { projectId } })
	}

	return { singleProjectTransition }
}
